class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("input"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  removeErrorMessage() {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;

    // Revert button from saying the error message
    const button = document.querySelector("[data-js-submit-cart]");
    if (button) {
      button.innerText = button.getAttribute("data-cta");
      button.removeAttribute("aria-disabled");
    }
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );

        if (source && destination) {
          destination.innerHTML = source.innerHTML;
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) {
          price.classList.remove("visibility-hidden");
        }

        const addButton = document.querySelector('[name="add"]');
        const addButtonText = addButton?.hasAttribute("data-is-coming-soon")
          ? window.variantStrings.comingSoon
          : window.variantStrings.soldOut;

        this.toggleAddButton(!this.currentVariant.available, addButtonText);

        const soldOutMessage = document.querySelector("[data-js-sold-out]");
        soldOutMessage.toggleAttribute("hidden", this.currentVariant.available);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) {
      return;
    }
    const addButton = productForm.querySelector('[name="add"]');
    if (!addButton) {
      return;
    }

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) {
        addButton.textContent = text;
      }
    } else {
      addButton.removeAttribute("disabled");
      // Show 'pre order' if it's a pre-order product
      addButton.textContent = addButton.hasAttribute("data-is-pre-order")
        ? window.variantStrings.preOrder
        : window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) {
      return;
    }
    const addButton = productForm.querySelector('[name="add"]');
    if (!addButton) {
      return;
    }

    addButton.textContent = addButton.hasAttribute("data-is-coming-soon")
      ? window.variantStrings.comingSoon
      : window.variantStrings.unavailable;

    if (price) {
      price.classList.add("visibility-hidden");
    }
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("[data-js-field]"));
    const matchedInputs = fieldsets.map((fieldset) => {
      const inputs = Array.from(fieldset.querySelectorAll("input"));
      return inputs.find((radio) => {
        if (radio.checked || radio.type === "hidden") {
          return radio.value;
        }
      });
    });
    this.options = Array.from(matchedInputs).map((input) => input.value);
  }
}

customElements.define("variant-radios", VariantRadios);
